import { StoreZigzinProduct } from '../components/StoreZigzinProduct';
import { useShippingZigzinProductService } from '../services/useShippingZigzinProductService';

export const ShippingStoreZigzinProductContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useShippingZigzinProductService();

  if (!service.shippingInfo) {
    return null;
  }
  return <StoreZigzinProduct {...service} shippingInfo={service.shippingInfo} />;
};
